export const LOCALE_US_EN = 'us/en'
export const LOCALE_GB_EN = 'gb/en'
export const LOCALE_CA_EN = 'ca/en'
export const LOCALE_NL_NL = 'nl/nl'
export const LOCALE_NL_EN = 'nl/en'
export const LOCALE_GEO = 'geo'

export const LOCALES_USING_IMPERIAL_SYSTEM = [LOCALE_US_EN, LOCALE_GEO]
export const ALLOWED_REGIONS = [LOCALE_US_EN, LOCALE_GB_EN, LOCALE_NL_NL, LOCALE_NL_EN]

export const DEFAULT_LOCALE = 'en'
export const ALLOWED_LOCALES = ['en', 'nl-nl']

export const DEFAULT_LANGUAGE_CODE = 'en'

export const PROD_HOSTNAMES = ['www.ikea.com', 'publicera.ingka.com', 'www.ppe.ikeadt.com']

// URL params
export const PARAM_SAVEONFIRSTRENDER = 'saveonfirstrender'
